import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UploaderService } from '../../services/uploader.service';
import { IImage, IEvent, IInteractionType } from '../../interfaces/definitions';
import { RequestsService } from '../../services/requests.service';
import { DetailPanelService } from './../../services/detail-panel.service';
import { Storage } from '../../services/storage';

declare var require: any;

@Component({
  selector: 'ng-media-grid-view',
  templateUrl: './grid-view.component.html',
  styleUrls: ['./grid-view.component.scss']
})
export class GridViewComponent implements OnInit {
  public images: Array<IImage> = [];
  public searchMode = false;
  public filteredImages: Array<IImage> = [];
  @Output() public selectionChange: EventEmitter<
    Array<IImage>
  > = new EventEmitter();
  @Output() public eventChange: EventEmitter<{
    type: string;
    payload?: any;
  }> = new EventEmitter();
  @Input() public InteractionType: IInteractionType = IInteractionType.Edit;
  @Input() public storage: Storage = null;

  constructor(
    private uploader: UploaderService,
    private panel: DetailPanelService
  ) {}

  ngOnInit() {
    this.uploader.events.subscribe((event: IEvent) => {
      if (event.type === 'SEARCH_START') {
        this.searchMode = true;
      }
      if (event.type === 'SEARCH_CLEAR') {
        this.searchMode = false;
      }
    });
    this.storage.GetSubsriber().subscribe((items: IImage[]) => {
      this.images = items.filter(Boolean);
    });
    this.storage.GetSearcher().subscribe((items: IImage[]) => {
      this.filteredImages = items;
    });
    this.storage.forceRefresh();
  }

  public GetSearchImages() {
    return this.filteredImages;
  }
}
